export const scrollToIndex = ( index, margin ) => {
	let track = document.querySelector( '.track' );
	let offsetLeft = index.offsetLeft;

	track.scrollTo({
		left: offsetLeft - margin,
		behavior: "smooth"
	});
}